/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { Header, Footer } from '@ikea-customer-self-serve/header-footer';
import { useEsi } from './utils';

// When there is no ESI header/footer we use default ones from package.
const HeaderFooterWrapper = ({ element }) => {
  return useEsi() ? (
    <React.Fragment>{element}</React.Fragment>
  ) : (
    <React.Fragment>
      <Header logoHref="/" />
      {element}
      <Footer />
    </React.Fragment>
  );
};

HeaderFooterWrapper.propTypes = {
  element: PropTypes.element.isRequired,
};

export default HeaderFooterWrapper;
